import { render } from "./WCSimpleReactiveQuantityAdjuster.vue?vue&type=template&id=a4488484&scoped=true"
import script from "./WCSimpleReactiveQuantityAdjuster.vue?vue&type=script&lang=js"
export * from "./WCSimpleReactiveQuantityAdjuster.vue?vue&type=script&lang=js"

import "./WCSimpleReactiveQuantityAdjuster.vue?vue&type=style&index=0&id=a4488484&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4488484"]])

export default __exports__